import { RootState } from 'store/rootReducer';

export const inviteUserToRoleState = (state: RootState) => state.features.adminPermission.inviteUserToRole;

export const confirmToInviteState = (state: RootState) => state.features.adminPermission.confirmToInvite;
